import React, {Component} from 'react';
import {connect} from "react-redux";
import {withTranslation} from 'react-i18next';
import {getSharingDetailsPopup} from "../../../../../../../../../actions/sharingDetailsActions";
import {msgBar} from '../../../../../../../../../actions/msgBarActions';
import Button from "../../../../../../../../components/button";

class EditLabelButton extends Component {

    constructor(props){
        super(props);

        this.handleClick = this.handleClick.bind(this);
    }

    handleClick(e){
        e.preventDefault();

        if(!e.currentTarget.dataset.disabled){
	        this.props.getSharingDetailsPopup([true, "rename_label", {labelId: this.props.labelId, labelName: this.props.labelName}]);
        } else {
	        e.currentTarget.style.cursor = 'not-allowed';
			this.props.msgBar(['error', this.props.t("msgBarErrorText5")]);
        }

    }

    render() {
        return (
            <Button className="btn-link" onClick={this.handleClick} data-disabled={this.props.disabled} aria-disabled={this.props.disabled} title={this.props.title}>
                <div className="more-option-item__picto">
                    <svg width="20" height="20" viewBox="0 0 24 24">
                        <path fill="none" d="M0 0h24v24H0V0z"/>
                        <path
                            fill="currentColor"
                            d="M14.06 9.02l.92.92L5.92 19H5v-.92l9.06-9.06M17.66 3c-.25 0-.51.1-.7.29l-1.83 1.83 3.75 3.75 1.83-1.83c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.2-.2-.45-.29-.71-.29zm-3.6 3.19L3 17.25V21h3.75L17.81 9.94l-3.75-3.75z"/>
                    </svg>
                </div>
                <div className="more-option-item__text">
                    <span>{this.props.title}</span>
                </div>
            </Button>

    );
    }
    }

    const mapStateToProps = (state) => {
    return {
        sharingDetailsPopup: state.sharingDetailsReducer.getSharingDetailsPopup,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getSharingDetailsPopup: (array) => {
		    dispatch(getSharingDetailsPopup(array))
	    },
	    msgBar: (array) => {
		    dispatch(msgBar(array))
	    },
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(EditLabelButton));
